// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-multi-carousel-dot-list{\n  visibility: visible !important; \n}\n", ""]);
// Exports
module.exports = exports;
